const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OpsCart = require("../vault/OpsCart");
const OpsUser = require("../../core/vault/OpsUser");
const Copy = require("../data/CopyTable");
const AssetsUtil = require("../../core/util/AssetsUtil");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const URLMake = require("../../../shared/URLMake");
const HearAboutBaSurveyModal = require("./HearAboutBaSurveyModal");

const styles = require("./styles/ConfirmSubmission.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ConfirmSubmission",

		propTypes: {
			user: PT.object.isRequired,
			cart: PT.object.isRequired,
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			resendCheckoutEmailsSuccess: function() {
				this.clearResendLoadingTimeout();
				this.setState({resendStatus: "success"});
			},
			resendCheckoutEmailsFail: function() {
				this.clearResendLoadingTimeout();
				this.setState({resendStatus: "error"});
			},
			hearAboutBaSurveyStatusLoaded: function({shouldShow}) {
				if (!shouldShow) {
					return;
				}
				const options = HearAboutBaSurveyModal.randomizeOptions(
					Copy.getHearAboutBaSurveyOptionsCopy()
				);
				this.setState({
					showHearAboutBaSurveyModal: true,
					hearAboutBaSurveyOptions: options,
				});
			},
			submitHearAboutBaSurveySuccess: function() {
				this.setState({
					showHearAboutBaSurveyModal: false,
					hearAboutBaSurveySubmitStatus: null,
				});
			},
			submitHearAboutBaSurveyFail: function() {
				this.setState({hearAboutBaSurveySubmitStatus: null});
			},
		},

		getInitialState: function() {
			return {
				resendStatus: "idle",
				showHearAboutBaSurveyModal: false,
				hearAboutBaSurveyOptions: null,
				hearAboutBaSurveySubmitStatus: null,
			};
		},

		componentDidMount: function() {
			const user = this.props.user;
			const lastFinishedCart = this.props.cart.lastFinishedCart;
			if (OpsUser.isLoggedIn(user) && user.userID && user.platformUserID) {
				this.props.dispatch({
					type: AT.LOAD_USER_PLATFORM_BASICS_REQUEST,
				});
			}
			const email = this.getCheckoutSurveyEmail();
			if (
				lastFinishedCart &&
				email &&
				AT.LOAD_HEAR_ABOUT_BA_SURVEY_STATUS_REQUEST
			) {
				this.props.dispatch({
					type: AT.LOAD_HEAR_ABOUT_BA_SURVEY_STATUS_REQUEST,
					email,
				});
			}
		},

		componentWillUnmount: function() {
			this.clearResendLoadingTimeout();
		},

		clearResendLoadingTimeout: function() {
			if (this._resendLoadingTimeout) {
				clearTimeout(this._resendLoadingTimeout);
				this._resendLoadingTimeout = null;
			}
		},

		getCheckoutSurveyEmail: function() {
			const cart = this.props.cart.lastFinishedCart;
			if (!cart) {
				return null;
			}
			const account = OpsCart.getFormSection(cart, "account");
			const contact = OpsCart.getFormSection(cart, "contact");
			const email =
				(account && account.email) || (contact && contact.email) || "";
			const trimmed = String(email).trim();
			return trimmed || null;
		},

		getHearAboutBaSurveyPayload: function() {
			const orderID = _.get(this.props.cart, "lastFinishedCart.orderID");
			const email = this.getCheckoutSurveyEmail();
			if (!orderID || !email) {
				return null;
			}
			return {email, orderID};
		},

		onHearAboutBaSurveySubmit: function({optionKey, otherText}) {
			const payload = this.getHearAboutBaSurveyPayload();
			if (!payload || !AT.SUBMIT_HEAR_ABOUT_BA_SURVEY_REQUEST) {
				return;
			}
			this.setState({hearAboutBaSurveySubmitStatus: "pending"});
			this.props.dispatch(
				_.assign({type: AT.SUBMIT_HEAR_ABOUT_BA_SURVEY_REQUEST}, payload, {
					optionKey,
					otherText,
				})
			);
		},

		onHearAboutBaSurveyDismiss: function() {
			this.setState({
				showHearAboutBaSurveyModal: false,
				hearAboutBaSurveySubmitStatus: null,
			});
			const payload = this.getHearAboutBaSurveyPayload();
			if (!payload || !AT.SUBMIT_HEAR_ABOUT_BA_SURVEY_REQUEST) {
				return;
			}
			this.props.dispatch(
				_.assign({type: AT.SUBMIT_HEAR_ABOUT_BA_SURVEY_REQUEST}, payload, {
					dismissed: true,
				})
			);
		},

		onClick: function(isEmailVerified) {
			if (isEmailVerified) {
				if (typeof window !== "undefined") {
					window.location.href = URLMake.forParentStudentPrimaryRegistration();
				}
				return;
			}
			const orderID = _.get(this.props.cart, "lastFinishedCart.orderID");
			if (!orderID) {
				return;
			}
			const confirmEmail = this.getCheckoutSurveyEmail() || "";
			this.clearResendLoadingTimeout();
			this._resendLoadingTimeout = setTimeout(() => {
				this._resendLoadingTimeout = null;
				this.setState(function(prev) {
					if (prev.resendStatus !== "loading") {
						return null;
					}
					return {resendStatus: "error"};
				});
			}, 45000);
			this.setState({
				resendStatus: "loading",
			});
			if (!AT.RESEND_CHECKOUT_EMAILS_REQUEST) {
				this.clearResendLoadingTimeout();
				this.setState({resendStatus: "error"});
				return;
			}
			this.props.dispatch({
				type: AT.RESEND_CHECKOUT_EMAILS_REQUEST,
				orderID,
				confirmEmail,
			});
		},

		render: function() {
			const {resendStatus} = this.state;
			const user = this.props.user;

			const cart = this.props.cart.lastFinishedCart;
			const hasSubscriptionItems = OpsCart.hasSubscriptionItems(cart.items);

			const {email} =
				OpsCart.getFormSection(cart, "account") ||
				OpsCart.getFormSection(cart, "contact");

			let isEmailVerified = null;
			if (
				OpsUser.isLoggedIn(user) &&
				user.userID &&
				user.platformUserID &&
				_.get(user, "model.platformEmailVerificationLoaded")
			) {
				isEmailVerified = _.get(user, "model.isEmailVerified");
			}

			const checkoutConfirmationCopy = Copy.getCheckoutConfirmCopy(
				hasSubscriptionItems,
				email,
				isEmailVerified
			);

			const checkoutConfirmationTitle =
				checkoutConfirmationCopy.checkoutConfirmationTitle;
			const checkoutConfirmationSubtitle =
				checkoutConfirmationCopy.checkoutConfirmationSubtitle;
			const resendEmailButtonText =
				checkoutConfirmationCopy.resendEmailButtonText;

			const resendDisabled =
				resendStatus === "loading" ||
				resendStatus === "success" ||
				resendStatus === "error";

			let resendButtonLabel = resendEmailButtonText;
			if (resendStatus === "loading") {
				resendButtonLabel = checkoutConfirmationCopy.resendEmailsLoading;
			} else if (resendStatus === "success") {
				resendButtonLabel = "Sent";
			} else if (resendStatus === "error") {
				resendButtonLabel = "Error";
			}
			let hearAboutBaSurveyModal;
			if (
				this.state.showHearAboutBaSurveyModal &&
				this.state.hearAboutBaSurveyOptions
			) {
				hearAboutBaSurveyModal = (
					<HearAboutBaSurveyModal
						options={this.state.hearAboutBaSurveyOptions}
						onSubmit={this.onHearAboutBaSurveySubmit}
						onDismiss={this.onHearAboutBaSurveyDismiss}
						status={this.state.hearAboutBaSurveySubmitStatus}
					/>
				);
			}

			return (
				<React.Fragment>
					<div className={styles.checkoutConfirmationContainer}>
						<div className={styles.checkoutConfirmationImageWrap}>
							<img
								className={styles.checkoutConfirmationImage}
								alt="Headmaster at his computer"
								src={AssetsUtil.getCheckoutImage(
									"headmaster-at-computer",
									"webp"
								)}
							/>
							<img
								className={styles.checkoutConfirmationSparkles}
								alt=""
								src={AssetsUtil.getCheckoutImage("sparkles", "gif")}
								aria-hidden="true"
							/>
						</div>
						<div className={styles.checkoutConfirmationTitle}>
							{checkoutConfirmationTitle}
						</div>
						<div className={styles.checkoutConfirmationSubtitle}>
							{checkoutConfirmationSubtitle}
						</div>
						<div className={styles.resendEmailsRow}>
							{(resendStatus === "idle" || resendStatus === "loading") && (
								<button
									type="button"
									className={styles.resendEmailsButton}
									onClick={() => this.onClick(isEmailVerified)}
									disabled={resendDisabled}
								>
									{resendButtonLabel}
								</button>
							)}
							{resendStatus === "success" && (
								<div className={styles.resendEmailConfirmation}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										viewBox="0 0 32 32"
										fill="none"
									>
										<path
											d="M26.6663 8L11.9997 22.6667L5.33301 16"
											stroke="#009951"
											strokeWidth="3"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
									Email sent. Still don't see it?{" "}
									<a className={styles.contactUsLink} href="/contact">
										Contact Us
									</a>
								</div>
							)}
							{resendStatus === "error" && (
								<div className={styles.resendEmailError}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										viewBox="0 0 32 32"
										fill="none"
									>
										<path
											d="M16.0003 10.666V15.9993M16.0003 21.3327H16.0137M10.4803 2.66602H21.5203L29.3337 10.4793V21.5193L21.5203 29.3327H10.4803L2.66699 21.5193V10.4793L10.4803 2.66602Z"
											stroke="#ED1940"
											strokeWidth="3"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
									Unable to resend email.{" "}
									<a className={styles.contactUsLink} href="/contact">
										Contact Us
									</a>
								</div>
							)}
						</div>
					</div>
					{hearAboutBaSurveyModal}
				</React.Fragment>
			);
		},
	})
);
